import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import SitemapGenerator from '@/utils/sitemapGenerator';

const SitemapTestPage = () => {
    const [sitemap, setSitemap] = useState('');
    const [loading, setLoading] = useState(false);
    const [copied, setCopied] = useState(false);

    const generateSitemap = async () => {
        setLoading(true);
        try {
            console.log('🚀 Testing sitemap generation...');
            const generator = new SitemapGenerator();
            const sitemapXml = await generator.generateSitemap();
            setSitemap(sitemapXml);
            toast.success('Sitemap сгенерирован успешно!');
        } catch (error) {
            console.error('❌ Error:', error);
            toast.error('Ошибка генерации sitemap');
        } finally {
            setLoading(false);
        }
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(sitemap);
        setCopied(true);
        toast.success('Скопировано в буфер обмена');
        setTimeout(() => setCopied(false), 2000);
    };

    const downloadSitemap = () => {
        const blob = new Blob([sitemap], { type: 'application/xml' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'sitemap.xml';
        a.click();
        URL.revokeObjectURL(url);
    };

    return (
        <div style={{ padding: '20px', maxWidth: '1200px' }}>
            <h1>🧪 Sitemap Generator Test</h1>
            <p>Эта страница для тестирования генерации sitemap</p>

            <div className="mb-4 flex gap-2">
                <Button onClick={generateSitemap} disabled={loading}>
                    {loading ? 'Генерация...' : '🚀 Сгенерировать Sitemap'}
                </Button>
                
                {sitemap && (
                    <>
                        <Button onClick={copyToClipboard} variant="outline">
                            {copied ? '✅ Скопировано' : '📋 Копировать'}
                        </Button>
                        <Button onClick={downloadSitemap} variant="outline">
                            💾 Скачать XML
                        </Button>
                    </>
                )}
            </div>

            {sitemap && (
                <Card>
                    <CardHeader>
                        <CardTitle>Результат генерации</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="mb-4">
                            <p><strong>Размер:</strong> {sitemap.length} символов</p>
                            <p><strong>URL найдено:</strong> {(sitemap.match(/<loc>/g) || []).length}</p>
                        </div>
                        
                        <details open>
                            <summary>Показать XML код</summary>
                            <div className="mt-4">
                                <pre className="bg-gray-50 p-4 rounded text-xs overflow-auto max-h-96 whitespace-pre-wrap font-mono border">
                                    {sitemap}
                                </pre>
                            </div>
                        </details>
                    </CardContent>
                </Card>
            )}

            {!sitemap && !loading && (
                <Card>
                    <CardContent className="pt-6">
                        <p>Нажмите "Сгенерировать Sitemap" чтобы начать тестирование</p>
                    </CardContent>
                </Card>
            )}
        </div>
    );
};

export default SitemapTestPage;
